import ModalsBootstrap from './modals-bootstrap';

export default ModalsBootstrap;


// WEBPACK FOOTER //
// ./src/ui-elements/modals-bootstrap/index.js